module.exports = __webpack_public_path__ + "static/media/startUp.c2c9ee9f.jpg";